import styled from 'styled-components';

export const StyledSection = styled.div`
  padding: 20px 0;
`;
